module.exports = __webpack_public_path__ + "img/icon_ai_more@2x.05889279.png";